import { EWalletId } from '@ankr.com/provider';
import { ConnectBtn } from 'modules/auth/components/ConnectBtn';
import { WalletIcon } from 'modules/auth/components/WalletIcon';
import { useTranslation } from 'modules/i18n';
import { useCallback } from 'react';
import { useConnection } from '../../../../hooks/useConnection';
import { IConnectButtonProps } from '../../types';
import { translation } from './translation';

export function ConnectWalletConnect({
  isDisabled,
}: IConnectButtonProps): React.JSX.Element {
  const { keys, t } = useTranslation(translation);
  const { connect, isLoading } = useConnection();

  const handleConnect = useCallback(
    () =>
      connect({
        walletKey: EWalletId.walletconnect,
      }),
    [],
  );

  return (
    <ConnectBtn
      onClick={handleConnect}
      isDisabled={isDisabled || isLoading}
      title={t(keys.title)}
      subtitle={t(keys.subtitle)}
      isLoading={isLoading}
      iconSlot={<WalletIcon wallet={EWalletId.walletconnect} />}
    />
  );
}
